/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationReasonWarning } from './ApplicationReasonWarning'
import {
  ApplicationReasonWarningFromJSON,
  ApplicationReasonWarningFromJSONTyped,
  ApplicationReasonWarningToJSON,
} from './ApplicationReasonWarning'
import type { CurrentApplicationStatus } from './CurrentApplicationStatus'
import {
  CurrentApplicationStatusFromJSON,
  CurrentApplicationStatusFromJSONTyped,
  CurrentApplicationStatusToJSON,
} from './CurrentApplicationStatus'
import type { ApplicationDocumentState } from './ApplicationDocumentState'
import {
  ApplicationDocumentStateFromJSON,
  ApplicationDocumentStateFromJSONTyped,
  ApplicationDocumentStateToJSON,
} from './ApplicationDocumentState'
import type { Documents } from './Documents'
import {
  DocumentsFromJSON,
  DocumentsFromJSONTyped,
  DocumentsToJSON,
} from './Documents'
import type { OwnerData } from './OwnerData'
import {
  OwnerDataFromJSON,
  OwnerDataFromJSONTyped,
  OwnerDataToJSON,
} from './OwnerData'
import type { OrganizationType } from './OrganizationType'
import {
  OrganizationTypeFromJSON,
  OrganizationTypeFromJSONTyped,
  OrganizationTypeToJSON,
} from './OrganizationType'

/**
 *
 * @export
 * @interface Application
 */
export interface Application {
  /**
   *
   * @type {string}
   * @memberof Application
   */
  uuid: string
  /**
   * Порядковый номер заявления в системе
   * @type {number}
   * @memberof Application
   */
  id: number
  /**
   *
   * @type {number}
   * @memberof Application
   */
  sysObjectId: number
  /**
   *
   * @type {CurrentApplicationStatus}
   * @memberof Application
   */
  currentStatus: CurrentApplicationStatus
  /**
   *
   * @type {ApplicationDocumentState}
   * @memberof Application
   */
  documentState: ApplicationDocumentState
  /**
   *
   * @type {ApplicationReasonWarning}
   * @memberof Application
   */
  reason: ApplicationReasonWarning | null
  /**
   *
   * @type {CurrentApplicationStatus}
   * @memberof Application
   */
  lastStatus: CurrentApplicationStatus
  /**
   *
   * @type {string}
   * @memberof Application
   */
  applicationFinishDate?: string
  /**
   * Номер сертификата выданного знака, который присваивает ФИПС выпущенным знакам
   * @type {string}
   * @memberof Application
   */
  certificateNumber?: string | null
  /**
   * Номер заявления, присваиваемый каждой заявке попадающей в общей государственный регистр ФИПС.
   * @type {string}
   * @memberof Application
   */
  regNumber?: string | null
  /**
   *
   * @type {string}
   * @memberof Application
   */
  regNumberLabel?: string | null
  /**
   *
   * @type {string}
   * @memberof Application
   */
  fipsSourceLink?: string | null
  /**
   *
   * @type {string}
   * @memberof Application
   */
  priorityDate?: string
  /**
   *
   * @type {OrganizationType}
   * @memberof Application
   */
  ownerType?: OrganizationType
  /**
   *
   * @type {OwnerData}
   * @memberof Application
   */
  ownerData?: OwnerData
  /**
   *
   * @type {string}
   * @memberof Application
   */
  applicationImageUrl?: string
  /**
   *
   * @type {Documents}
   * @memberof Application
   */
  documents?: Documents
  /**
   *
   * @type {string}
   * @memberof Application
   */
  linkInAdmin?: string
}

/**
 * Check if a given object implements the Application interface.
 */
export function instanceOfApplication(value: object): value is Application {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('sysObjectId' in value) || value['sysObjectId'] === undefined)
    return false
  if (!('currentStatus' in value) || value['currentStatus'] === undefined)
    return false
  if (!('documentState' in value) || value['documentState'] === undefined)
    return false
  if (!('reason' in value) || value['reason'] === undefined) return false
  if (!('lastStatus' in value) || value['lastStatus'] === undefined)
    return false
  return true
}

export function ApplicationFromJSON(json: any): Application {
  return ApplicationFromJSONTyped(json, false)
}

export function ApplicationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Application {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    id: json['id'],
    sysObjectId: json['sysObjectId'],
    currentStatus: CurrentApplicationStatusFromJSON(json['currentStatus']),
    documentState: ApplicationDocumentStateFromJSON(json['documentState']),
    reason: ApplicationReasonWarningFromJSON(json['reason']),
    lastStatus: CurrentApplicationStatusFromJSON(json['lastStatus']),
    applicationFinishDate:
      json['applicationFinishDate'] == null
        ? undefined
        : json['applicationFinishDate'],
    certificateNumber:
      json['certificateNumber'] == null ? undefined : json['certificateNumber'],
    regNumber: json['regNumber'] == null ? undefined : json['regNumber'],
    regNumberLabel:
      json['regNumberLabel'] == null ? undefined : json['regNumberLabel'],
    fipsSourceLink:
      json['fipsSourceLink'] == null ? undefined : json['fipsSourceLink'],
    priorityDate:
      json['priorityDate'] == null ? undefined : json['priorityDate'],
    ownerType:
      json['ownerType'] == null
        ? undefined
        : OrganizationTypeFromJSON(json['ownerType']),
    ownerData:
      json['ownerData'] == null
        ? undefined
        : OwnerDataFromJSON(json['ownerData']),
    applicationImageUrl:
      json['applicationImageUrl'] == null
        ? undefined
        : json['applicationImageUrl'],
    documents:
      json['documents'] == null
        ? undefined
        : DocumentsFromJSON(json['documents']),
    linkInAdmin: json['linkInAdmin'] == null ? undefined : json['linkInAdmin'],
  }
}

export function ApplicationToJSON(value?: Application | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    id: value['id'],
    sysObjectId: value['sysObjectId'],
    currentStatus: CurrentApplicationStatusToJSON(value['currentStatus']),
    documentState: ApplicationDocumentStateToJSON(value['documentState']),
    reason: ApplicationReasonWarningToJSON(value['reason']),
    lastStatus: CurrentApplicationStatusToJSON(value['lastStatus']),
    applicationFinishDate: value['applicationFinishDate'],
    certificateNumber: value['certificateNumber'],
    regNumber: value['regNumber'],
    regNumberLabel: value['regNumberLabel'],
    fipsSourceLink: value['fipsSourceLink'],
    priorityDate: value['priorityDate'],
    ownerType: OrganizationTypeToJSON(value['ownerType']),
    ownerData: OwnerDataToJSON(value['ownerData']),
    applicationImageUrl: value['applicationImageUrl'],
    documents: DocumentsToJSON(value['documents']),
    linkInAdmin: value['linkInAdmin'],
  }
}
